module.exports = __webpack_public_path__ + "images/DPL90948b29c4cc22af1d2a5b361e8d6f52.jpg";